import ModalRegistrationResponse from "root/s360components/Modals/Registration/ModalRegistrationResponse";
import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddConcernReport from "root/s360components/Modals/ConcernReport/ModalAddConcernReport";

const useModalRegistrationResponse = () =>
{

    const [dialog, setDialog]  = useState ( {
        openState: false, class_name: null, session: null
    })  ;

    const onClickActivate = ( class_name, session, showEmptyResponse ) =>
    {
        setDialog ({
            openState: true,
            class_name: class_name,
            session: session,
            showEmptyResponse: showEmptyResponse
        });
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, class_name: null, session: null});
    };


    const render = ( ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                    < ModalRegistrationResponse onClose={onCloseModal} class_name={dialog.class_name} session={dialog.session} showEmptyResponse={dialog.showEmptyResponse} />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalRegistrationResponse;